import { SET_AUTH, LOG_OUT } from "./mutation-types";
const kAuth = "auth";
const {
  userInfo,
  token,
} = JSON.parse(localStorage.getItem(kAuth)) || {
  userInfo: null,
  token: null,
};
// 获取urltoken
const getQueryVariable = variable => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return "-1";
};

export default {
  state: {
    userInfo: userInfo,
    token: token,
  },
  getters: {
    isLogging(state) {
      if (getQueryVariable("token") !== "-1" && !state.token) {
        const auth = {
          userInfo: null,
          token: getQueryVariable("token")
        };
        localStorage.setItem(kAuth, JSON.stringify(auth));
        return true;
      } else if (state.token) {
        return true;
      } else {
        return false;
      }
    },
    tokenHeaders(state, getters) {
      if (!getters.isLogging) return {};
      return { Authorization: "Bearer " + state.token };
    }
  },
  mutations: {
    [SET_AUTH](state, data) {
      if (data) state.userInfo = data;
      if (data.Token) state.token = data.Token;
      const login = {
        userInfo: state.userInfo,
        token: state.token,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
    },
    [LOG_OUT](state) {
      state.userInfo = null;
      state.token = null;
      const login = {
        userInfo: null,
        token: null,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
      localStorage.setItem("MenuList", null);
    }
  }
};
